import { getCmsNetworkMapStationInfoAction } from "../../../Actions/LogicActions/CmsNetworkMapStations/getCmsNetworkMapStationInfoAction";
import { getCmsNetworkMapStationsWithoutBestPriceAction } from "../../../Actions/LogicActions/CmsNetworkMapStations/GetCmsNetworkMapStationsWithoutBestPriceAction";
import { stationMoreDetailClickAction } from "../../../Actions/UIActions/CmsNetworkMapStations/StationMoreDetailClickAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";

class NetworkMapStationInitStep extends StepFlow {
    get stepName() { return "NetworkMapStationInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: evtTree.Network.Get,
                handler: async ({ }) => {
                    // this action will get stations with price
                    // await getCmsNetworkMapStationsAction.execute();
                    await getCmsNetworkMapStationsWithoutBestPriceAction.execute();
                    await getCmsNetworkMapStationInfoAction.execute();
                },
            })
        );

        this.registerEventSubscription(
            _eventBus.on({
                eventName: evtTree.Network.GetDetails.Click,
                handler: async (data: any) => {
                    stationMoreDetailClickAction.setParams(data.data)
                    await stationMoreDetailClickAction.execute();
                },
            })
        );
    }

    async onExecute(): Promise<void> {
        console.log("NetworkMapStation Init Step Execute...")
        _eventBus.emit({
            eventName: evtTree.Network.Get,
        });
    }
}

export const NetworkMapStationInitStepDeclaration = new StepDefinition({
    stepName: "NetworkMapStationInit_Step",
    stepClass: NetworkMapStationInitStep
});